export const createFormFieldConfig = (name, placeholder, label, type = null, htmlFor = null, show = true) => {
  return {
    id: name,
    name,
    placeholder,
    type: type || name,
    htmlFor: htmlFor || name,
    labelText: label,
    show: show,
  };
};
